import Vue from 'vue'
import Router from 'vue-router'
import DefaultLayout from './layouts/Default.vue'
import { Home, Chipping, SpeedsFeeds, Performance, Geometry } from './views'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: '/geometry',
          name: 'geometry',
          component: Geometry
        },
        {
          path: '/chipping',
          name: 'chipping',
          component: Chipping
        },
        {
          path: '/speeds_feeds',
          name: 'speeds_feeds',
          component: SpeedsFeeds
        },
        {
          path: '/performance',
          name: 'performance',
          component: Performance
        }
      ]
    }
  ]
})
